// extracted by mini-css-extract-plugin
export default {"root":"Review__root--Yg8LZ","title":"Review__title--Vz4rk","address":"Review__address--_lQAn","rating":"Review__rating--k4S3b","body":"Review__body--ZYePO"};